import {
  CreateDropBoxRequestInterface,
  UpdateDropBoxRequestInterface,
  DeleteDropBoxRequestInterface,
} from '@/data/payload/contracts/DropBoxRequest'

export class CreateDropBoxRequest implements CreateDropBoxRequestInterface {
  public name: string
  public serialNumber: string
  public lat: number
  public long: number
  public address: string
  public phoneNumber: string
  public picAgentCode: string
  public visibility: string

  constructor(
    name: string,
    serialNumber: string,
    lat: number,
    long: number,
    address: string,
    phoneNumber: string,
    picAgentCode: string,
    visibility: string
  ) {
    this.name = name
    this.serialNumber = serialNumber
    this.lat = lat
    this.long = long
    this.address = address
    this.phoneNumber = phoneNumber
    this.picAgentCode = picAgentCode
    this.visibility = visibility
  }

  public toPayload(): FormData {
    const data = new FormData()
    data.append('name', this.name)
    data.append('serial_number', this.serialNumber)
    data.append('lat', this.lat.toString())
    data.append('long', this.long.toString())
    data.append('address', this.address)
    data.append('phone_number', String(this.phoneNumber))
    data.append('agent_code', this.picAgentCode)
    data.append('visibility', this.visibility)
    return data
  }
}

export class UpdateDropBoxRequest implements UpdateDropBoxRequestInterface {
  public externalId: string
  public name: string
  public serialNumber: string
  public lat: number
  public long: number
  public address: string
  public phoneNumber: string
  public picAgentCode: string
  public visibility: string

  constructor(
    externalId: string,
    name: string,
    serialNumber: string,
    lat: number,
    long: number,
    address: string,
    phoneNumber: string,
    picAgentCode: string,
    visibility: string
  ) {
    this.externalId = externalId
    this.name = name
    this.serialNumber = serialNumber
    this.lat = lat
    this.long = long
    this.address = address
    this.phoneNumber = phoneNumber
    this.picAgentCode = picAgentCode
    this.visibility = visibility
  }

  public toPayload(): FormData {
    const data = new FormData()
    data.append('external_id', this.externalId)
    data.append('name', this.name)
    data.append('serial_number', this.serialNumber)
    data.append('lat', this.lat.toString())
    data.append('long', this.long.toString())
    data.append('address', this.address)
    data.append('phone_number', String(this.phoneNumber))
    data.append('agent_code', this.picAgentCode)
    data.append('visibility', this.visibility)
    return data
  }
}

export class DeleteDropBoxRequest implements DeleteDropBoxRequestInterface {
  public externalId: string

  constructor(externalId: string) {
    this.externalId = externalId
  }

  public toPayload(): Record<string, string> {
    return {
      external_id: this.externalId,
    }
  }
}
